<template>
  <div class="index-page container">
    <div class="main-container-header">
      <div class="main-container-header__title">
        <h2>Dashboard</h2>
      </div>
    </div>
    <div class="panel" v-if="isLogged()">
      <div class="panel-body">
        <div class="agency__wrapper">
          <div class="agency__grid">
            <div class="agency__item">
              <div class="agency__text">
                <h2>Your Agency Details</h2>
                <p>Agency Name: <b>{{ agency }}</b></p>
                <p>Agency Status: <b>{{ agencyStatus ? 'active' : 'inactive' }}</b></p>
                <p>Agent Email: <b>{{ agentEmail }}</b></p>
                <p v-if="activeAgents > -1 ">Number of Agents: <b> {{ activeAgents }}</b></p>
                <p v-if="activeAgencies > -1">Number of Subagencies: <b>{{ activeAgencies }}</b></p>
                <p v-if="airlinesText">Enabled airlines: <b>{{ airlinesText }}</b></p>
                <p v-if="plan">Plan: <b>{{ plan }}</b></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="homeSectionContainer wrapper">
      <div class="homeProductsGrid">
        <div class="homeProductsItem">
          <div class="homeProductsItem__image">
            <img
                height="32"
                width="32"
                :src="require('@/assets/images/icon-desktop.svg')"
            />
          </div>
          <div class="homeProductsItem__text">
            <h2 class="">Agent Desktop</h2>
            <p>
              If you already have an account and your admin has setup your
              agency's credentials to call airlines, you can
              <a href="https://app.airgateway.net/">use Bookingpad</a>, our NDC
              Agency Desktop Solution.
            </p>
            <div>
              <a
                  class="btn btn-primary"
                  @click="goToLogin()"
                  href="#"
                  role="button"
              >Log In to Bookingpad
              </a>
            </div>
          </div>
        </div>

        <div class="homeProductsItem">
          <div class="homeProductsItem__image">
            <img
                height="32"
                width="32"
                :src="require('@/assets/images/icon-api.svg')"
            />
          </div>
          <div class="homeProductsItem__text">
            <h2>API Developer Guide</h2>
            <p>
              Read our API developer guide to get a brief idea on what our
              API can provide.
            </p>
            <div>
              <a
                  class="btn btn-primary-outline"
                  href="https://dev-guides.airgateway.net/"
                  target="_blank"
                  role="button"
              >Read the Docs
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationBar from "./shared/+navigation-bar";
import axios from "@/services/axios";
import helpers from "@/mixins/helpers";

export default {
  data() {
    return {
      activeAgents: -1,
      activeAgencies: -1,
      plan: '',
      airlines: [],
    }
  },
  mixins: [helpers],
  components: {
    NavigationBar
  },
  mounted: function () {
    if (this.$localStorage.get("logged")) {

      if (this.can('front.account')) {
        axios.get("/agent/access/account/list")
            .then(res => {
              this.activeAgents = res.data.filter(a => a.status === 'active').length;
            })
      }

      if (this.can('front.subagency')) {
        axios.get("/agent/access/agency/list")
            .then(res => {
              this.activeAgencies = res.data.length;
            })
      }

      if (this.can('front.airlines')) {
        axios.get("/agent/account/airlines")
            .then(res => {
              this.airlines = res.data;
            });
      }
    }
  },
  computed: {
    agentEmail() {
      return this.$localStorage.get('email');
    },
    agency() {
      return this.$localStorage.get('agency');
    },
    agencyStatus() {
      return this.$localStorage.get('agencyStatus') === 'true';
    },
    airlinesText() {
      const enabledAirlines = Object.entries(this.airlines)
          .filter(([_, airline]) => airline.value)
          .map(([key, _]) => key);

      return enabledAirlines.join(', ');
    },
    isConsumerOwner() {
      return this.$localStorage.get("isConsumerOwner") === 'true';
    },
  },
  methods: {
    isLogged() {
      return this.$localStorage.get("logged");
    },
    goToLogin() {
      let url = process.env.VUE_APP_BACKOFFICE_URL;
      var win = window.open(url, '_blank');
      win.focus();
    }
  }
};
</script>

<style lang="scss">

</style>
